import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Form } from 'react-bootstrap-5';
import { isPresent } from 'helpers/string_helpers';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';

class CityFilter extends React.Component {
  static propTypes = {
    cities: PropTypes.arrayOf(PropTypes.string).isRequired,
    currentCity: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  };

  state = {
    active: false,
  };

  inputRef = React.createRef();
  wrapperRef = React.createRef();

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = () => {
    const { onChange, currentCity } = this.props;
    if (isPresent(currentCity)) {
      onChange(currentCity, 'cities');
    }

    this.setState({ active: false });
  };

  handleKeyPress = (e) => {
    const { onChange, currentCity } = this.props;
    if (e.key === 'Enter' && isPresent(currentCity)) {
      onChange(currentCity, 'cities');
    }
  };

  handleRemove = (city) => {
    const { onChange } = this.props;
    onChange(city, 'cities');
  };

  renderRemoveLink(city) {
    return (
      <FontAwesomeIcon
        icon={faCircleXmark}
        name="remove-icon"
        size="sm"
        onClick={() => this.handleRemove(city)}
      />
    );
  }

  renderCityChip = (city) => {
    return (
      <div className="city-box" key={city}>
        <div className="badge badge-muted badge-secondary">
          <div>{city}</div>
          {this.renderRemoveLink(city)}
        </div>
      </div>
    );
  };

  renderCities() {
    const { cities } = this.props;

    if (cities.length > 0) {
      return (
        <div className="cities-bucket mt-1 d-flex align-items-center gap-1 flex-wrap" style={{ maxWidth: '300px' }}>
          {cities.map(c => this.renderCityChip(c))}
        </div>
      );
    }
  }

  renderCityInput() {
    const { cities, currentCity, onChange } = this.props;

    return (
      <input
        autoComplete="off"
        autoFocus={false}
        className="form-control"
        placeholder={cities.length === 0 ? 'City' : 'Enter another city'}
        ref={this.inputRef}
        value={currentCity}
        onChange={e => onChange(e, 'currentCity')}
        onClick={() => this.setState({ active: true })}
        onKeyPress={this.handleKeyPress}
      />
    );
  }

  render() {
    const { active } = this.state;
    const { cities } = this.props;

    const containerClass = classNames({
      active: active,
      'h-100': cities.length > 0,
      'd-inline-flex': cities.length === 0,
    });

    return (
      <div className="d-flex flex-column gap-2">
        <Form.Label>City</Form.Label>
        <div className={containerClass} ref={this.wrapperRef}>
          {this.renderCityInput()}
          {this.renderCities()}
        </div>
      </div>
    );
  }
}

export default CityFilter;
